import React, { Component } from "react";
import { Grid, Paper } from "@material-ui/core";
import InputFormat from "../../../partials/inputForm";
import { style } from "./styles";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getNumberOnString } from "../../../partials/validateNumber";
import DescriptionComponent from "../../descriptionComponent";

class Description extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product || {},
    };
  }
  async componentDidMount() {}
  componentWillReceiveProps = (nextProps) => {
    let _this = this;
    if (nextProps.product && nextProps.product.id !== this.state.product.id)
      this.setState(
        {
          product: nextProps.product,
        },
        function () {
          _this.DescriptionComponent.changeDescription(
            nextProps.product.description || ""
          );
        }
      );
  };
  handleChange = (e) => {
    let { product } = this.state;
    if (e.target.name === "position")
      product[e.target.name] = getNumberOnString(e.target.value);
    else product[e.target.name] = e.target.value;
    this.setState(product);
  };
  handleSubComponentChange = (name, value) => {
    let { product } = this.state;
    product[name] = value;
    this.setState(product);
  };
  render() {
    const { classes, t } = this.props;
    return (
      <Paper className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              required
              label={t("product_name")}
              name="name"
              value={this.state.product.name}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              // required
              label={t("product_slug")}
              name="slug"
              value={this.state.product.slug}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              // required
              label={t("product_page_title")}
              name="meta_title"
              value={this.state.product.meta_title}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              // required
              label={t("product_meta_description")}
              name="meta_description"
              value={this.state.product.meta_description}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              title={t("product_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={this.state.product.description}
              nameInput="description"
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(Description)));
